import { RET_RAW, apiFetch } from "../api";
import { toApiFilter } from "./exportNewsDataManipulator";

const PREFIX = process.env.REACT_APP_URL_EXPORT_NEWS_ROOT;

export const exportAllToExcel = (filters) => {
  return apiFetch(`${PREFIX}all/excel`, toApiFilter(filters), "POST", RET_RAW);
};

export const exportAllToWord = (filters, options = { showRating: false, showImpact: false }) => {
  const queryParams = [options.showRating && "showRating=true", options.showImpact && "showImpact=true"]
    .filter(Boolean)
    .join("&");
  return apiFetch(`${PREFIX}all/word?${queryParams || ""}`, toApiFilter(filters), "POST", RET_RAW);
};

export const exportArticlesToExcel = (articleIds) => {
  return apiFetch(`${PREFIX}article/excel`, articleIds, "POST", RET_RAW);
};

export const exportSelectedNewsToExcel = (articleIds) => {
  return apiFetch(`${PREFIX}news/selected/excel`, articleIds, "POST", RET_RAW);
};

export const exportFilteredNewsToExcel = (filters) => {
  return apiFetch(`${PREFIX}news/filtered/excel`, filters, "POST", RET_RAW);
};

export const exportSelectedEventsToExcel = (eventIds) => {
  return apiFetch(`${PREFIX}event/selected/excel`, eventIds, "POST", RET_RAW);
};

export const exportFilteredEventsToExcel = (filters) => {
  return apiFetch(`${PREFIX}event/filtered/excel`, filters, "POST", RET_RAW);
};

export const exportType = (type) => {
  return apiFetch(`${PREFIX}right/excel/${type}`, null, "POST", RET_RAW);
};

const AVAILABLE_RATING_EXPORT_TYPES = ["source", "create", "publication"];
export const exportRatings = (filters) => {
  if (!AVAILABLE_RATING_EXPORT_TYPES.includes(filters?.source))
    throw Error("Invalid source value: " + filters?.source || "");
  if (!filters?.dateFrom || !(filters.dateFrom instanceof Date)) throw Error("Invalid dateFrom value");
  if (!filters?.dateTo || !(filters.dateTo instanceof Date)) throw Error("Invalid dateTo value");

  const dateAttribute =
    filters.source === "source"
      ? "issuedDateRange"
      : filters.source === "create"
      ? "creationDateRange"
      : "publishedDateRange";

  return apiFetch(
    `${PREFIX}multirating/excel`,
    { [dateAttribute]: { start: filters.dateFrom.toISOString(), end: filters.dateTo.toISOString() } },
    "POST",
    RET_RAW
  );
};
